import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { useRazorpay, RazorpayOrderOptions } from "react-razorpay";
import { RAZORPAY_CLIENT_ID } from "@constant";
import { priceDisplayLocally } from "@utilscommon";
import LocaleStrings from "@language";

const CheckoutForm = (props) => {
  const { error, isLoading, Razorpay } = useRazorpay();
  const location = useLocation();
  const navigate = useNavigate();
  const { eventData, onlinePaymentKeys, amount, currency, buyerinfo } = props;
  const browserLanguage = navigator.language || navigator.userLanguage;
  // console.log(browserLanguage); // Example output: "en-US"
  // console.log("eventData :- ", eventData);

  const handlePayment = () => {
    // const options: RazorpayOrderOptions = {
    const options = {
      key: RAZORPAY_CLIENT_ID,
      amount: amount * 100, // Amount in paise
      currency: currency,
      name: eventData.eventname,
      description: "",
      order_id: onlinePaymentKeys.id, // Generate order_id on server
      handler: (response) => {
        // console.log(response);
        // alert("Payment Successful!");
        let param = location.search;
        navigate(`/razorpay_callback/${onlinePaymentKeys.id}${param}`, {
          state: {
            paymentid: response.razorpay_payment_id,
            orderid: response.razorpay_order_id,
            signature: response.razorpay_signature,
          },
        });
      },
      hidden: { contact: true },
      prefill: {
        name: buyerinfo.name,
        email: buyerinfo.email,
        contact: "0",
        method: "card",
      },
      theme: {
        color: `${eventData.themecolor}`,
      },
      modal: { confirm_close: true },
      config: {
        display: {
          language: browserLanguage,
        },
      },
    };

    const razorpayInstance = new Razorpay(options);
    razorpayInstance.open();
  };

  // console.log("error, isLoading", error, isLoading);

  return (
    <>
      {/* Show any error or success messages */}

      {error && (
        <div className="payment-error-message" id="payment-error-message">
          {error}
        </div>
      )}

      <div id="razorpay-payment-form" className="razorpay-payment-form">
        {isLoading ? (
          ""
        ) : (
          <button
            className="theme-button-md w-full"
            disabled={isLoading}
            id="submit"
            type="button"
            onClick={handlePayment}
          >
            <span id="button-text">
              {_.replace(
                LocaleStrings.kPayAmountText,
                "#amount",
                `${currency} ${priceDisplayLocally(amount)}`
              )}
            </span>
          </button>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
  eventData: state.eventData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
